import useSWR from "swr";

import { type GovernanceUnitNode } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/governance-units";

export function useGovernanceUnits() {
  return useSWR<GovernanceUnitNode[], Error>(url, simpleFetcher, {
    revalidateOnFocus: false,
  });
}
